<template>
    <div>
        <app-sub-title text="Filtros" />
        <div class="d-flex align-items-center">
            <div class="px-2" v-if="venues">
                <app-form-select-input
                    placeholder="Seleccione sede"
                    v-model="filters.venueId"
                    :options="venues"
                />
            </div>
            <div class="px-2">
                <app-form-text-input 
                    v-model="filters.firstName"
                    placeholder="Nombre"
                />
            </div>
            <div class="px-2">
                <app-form-text-input 
                    v-model="filters.lastName"
                    placeholder="Apellido"
                />
            </div>
            <div class="px-2">
                <b-button variant="primary" @click="$emit('filter', filters)"><i class="fa fa-filter"></i></b-button>
            </div>
            <div class="px-2">
                <b-button variant="secondary" @click="clearFilters"><i class="fa fa-times-circle"></i></b-button>
            </div>
        </div>
    </div>
</template>
<script>
import clientsRepository from '../../../../../repositories/clients.repository.js';
export default {
    props: {
        venues: {
            type: Array
        }
    },
    data(){
        return {
            filters: {
                firstName: '',
                lastName: '',
                venueId: ''
            }
        }
    },
    methods: {
        clearFilters(){
            Object.keys(this.filters).map(key => this.filters[key] = '');
            this.$emit('filter', null);
        }
    }
}
</script>

